export const statusCODCharge = {
  readyToCharge: 'readyToCharge',
  missingCard: 'missingCard',
  blockingCharge: 'blockingCharge',
};

export const checkCODTerm = (term) => term?.toLowerCase() === 'cod';

export const checkStatusCODCharge = ({
  hasCreditCard,
  hasPermissionMemberBillingProperties,
  hasPermissionPayWithMemberCC,
}) => {
  if (hasCreditCard)
    return hasPermissionPayWithMemberCC && statusCODCharge.readyToCharge;

  if (hasPermissionMemberBillingProperties) return statusCODCharge.missingCard;

  return statusCODCharge.blockingCharge;
};

const PRODUCT_OF_RIVIR = 'RP';
const DEFAULT_QUANTITY = 1;

const mappingProductOfRivir = (productId) => {
  return `${PRODUCT_OF_RIVIR}${productId}`;
};

export const transformChargeItemsForCOD = (chargeItems = []) => {
  let result = [];

  chargeItems.forEach((item) => {
    const { productId, hierarchyId, fee, gtin } = item;
    const hasHierarchy = Boolean(hierarchyId);

    result.push({
      lineItemId: productId,
      hierarchyId: hasHierarchy ? hierarchyId : null,
      lineItemNumber: mappingProductOfRivir(productId),
      lineItemDescription: hasHierarchy
        ? `Hierarchy_${gtin}`
        : `Product_${gtin}`,
      quantity: DEFAULT_QUANTITY,
      amount: fee,
    });
  });

  return result;
};
